import Fetch from "@/utils/Fetch";
import objectToFormData from "@/utils/ObjectToFormData";
import executeRecaptcha from "@/utils/ExecuteRecaptcha";


export default {
    namespaced: true,
    state() {
        return {
            formInitials: JSON.parse(sessionStorage.getItem('_vacancyFormInitials')) || null,
        }
    },
    mutations: {
        setFormInitials(state, initialsData) {
            if (!initialsData) return
            state.formInitials = initialsData
            sessionStorage.setItem('_vacancyFormInitials', JSON.stringify(initialsData))
        },
    },
    actions: {
        async loadFormInitials({commit}) {
            let response = await Fetch('forms/job/initials/')
            if (response.success) {
                commit('setFormInitials', response.data)
                return response
            } else {
                return response
            }
        },
        async sendVacancyForm({commit}, {formData}) {
            
            let token 
            await executeRecaptcha().then(async (tokenRecaptcha) => token = tokenRecaptcha)

            let body = objectToFormData({
                fio: formData.fio,
                job: formData.job,
                city: formData.city,
                phone: formData.phone,
                email: formData.email,
                message: formData.message,
                resume: formData.resume,
                token
            })
            let response = await Fetch('forms/job/', {
                method: 'POST',
                body
            })
            if (response.success) {
                commit('setPopupSuccessData', {title: 'Заявка отправлена!', message: response.message}, {root: true})
                return response
            } else {
                commit('setPopupSuccessData', {title: 'Что-то пошло не так!', message: response.message}, {root: true})
                return response
            }
        },

        async sendVacancyAskForm({commit}, {formData}) {

            let token 
            await executeRecaptcha().then(async (tokenRecaptcha) => token = tokenRecaptcha)
            
            let body = objectToFormData({
                fio: formData.fio,
                city: formData.city,
                email: formData.email,
                message: formData.message,
                resume: formData.resume,
                token
            })
            let response = await Fetch('forms/job/find/', {
                method: 'POST',
                body
            })
            if (response.success) {
                commit('setPopupSuccessData', {title: 'Заявка отправлена!', message: response.message}, {root: true})
                return response
            } else {
                commit('setPopupSuccessData', {title: 'Что-то пошло не так!', message: response.message}, {root: true})
                return response
            }
        },
    },
    getters: {
        getFormInitials: state => state.formInitials
    }
}